import { Validator } from '../Validator';
import mapViewGeoJsonSchema from './schema.json';
export const validateMapViewStationData = new Validator(mapViewGeoJsonSchema).validate;
